import modernizr from "script-loader!./vendor/modernizr.min.js"
import storeModern from "script-loader!./vendor/store.modern.min.js"
import magnificPopup from "script-loader!./vendor/jquery.magnific-popup.min.js"
import accessibleTabs from "script-loader!./vendor/jquery-accessible-tabs.js"
import handlebars from "script-loader!./vendor/handlebars.min.js"
import slick from "script-loader!./vendor/slick.min.js"
import zoom from "script-loader!./vendor/jquery.zoom.min.js"
import toastr from "script-loader!./vendor/toastr.min.js"
import countdown from "script-loader!./vendor/countdown.min.js"
import stickykit from "script-loader!./vendor/sticky-kit.min.js"

import a11y from "script-loader!./slate/a11y.js"
import cart from "script-loader!./slate/cart.js"
import utils from "script-loader!./slate/utils.js"
import rte from "script-loader!./slate/rte.js"
import sections from "script-loader!./slate/sections.js"
import currency from "script-loader!./slate/currency.js"
import images from "script-loader!./slate/images.js"
import variants from "script-loader!./slate/variants.js"

import geoip from "script-loader!./theme/geoip.js"
import siteNav from "script-loader!./theme/site-nav.js"
import modals from "script-loader!./theme/modals.js"
import localeswitcher from "script-loader!./theme/localeswitcher.js"
import slider from "script-loader!./theme/slider.js"
import drawers from "script-loader!./theme/drawers.js"
import mobileNav from "script-loader!./theme/mobile-nav.js"
import countdowns from "script-loader!./theme/countdowns.js"
import sticky from "script-loader!./theme/sticky.js"
import newsletter from "script-loader!./theme/newsletter.js"
import collectionToolbar from "script-loader!./theme/collection-toolbar.js"
import collectionFilter from "script-loader!./theme/collection-filter.js"
import quickview from "script-loader!./theme/quickview.js"
import quickshop from "script-loader!./theme/quickshop.js"
import promoBlockSlider from "script-loader!./theme/promo-block-slider.js"

import product from "script-loader!./sections/product.js"
import productLook from "script-loader!./sections/product-look.js"
import collection from "script-loader!./sections/collection.js"
import upsellProduct from "script-loader!./sections/upsell-product.js"
import productQuickshop from "script-loader!./sections/product-quickshop.js"
import asset from "script-loader!./sections/asset.js"

import customerAddresses from "script-loader!./templates/customers-addresses.js"
import customerLogin from "script-loader!./templates/customers-login.js"

import prepareTransition from "script-loader!./vendor/prepareTransition.js"
import fancybox from "script-loader!../../node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min.js"

import { picoapp } from 'picoapp';
import exitNag from './components/exitNag';
import regionRedirect from './components/regionRedirect';

const components = {
  exitNag,
  regionRedirect,
};

const state = {};

var app = picoapp(components, state);

bb.Notifications = function(options) {
  var action = options.action != null ? options.action : void 0;
  var message = options.message;

  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
    onclick: null,
    extendedTimeOut: '1000',
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut'
  };

  switch (action) {
    case "close": {
      toastr.clear();
      break;
    }
    case "notice": {
      toastr.info(message);
      break;
    }
    case "error": {
      toastr.error(message);
      break;
    }
  }
};

// Debounce function
bb.debounce = function(func, wait, immediate) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

$(document).ready(function() {
  theme.cache = {
    // General
    $html: $('html'),
    $body: $(document.body),
    $countdown: $('[countdown]')
  };

  var sections = new slate.Sections();
  sections.register('product', theme.Product);
  sections.register('product-look', theme.ProductLook);
  sections.register('collection', theme.Collection);
  sections.register('asset', theme.Asset);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Wrap videos in div to force responsive layout.
  slate.rte.wrapTable();
  slate.rte.iframeReset();

  // Load page modals
  theme.modals.load();

  // Load mobile nav
  theme.MobileNav.load();

  // Load site nav
  theme.SiteNav();

  // Load newsletter
  theme.Newsletter.load();

  // Load Collection Toolbar
  theme.CollectionToolbar.load();

  // Load Collection Filter
  theme.CollectionFilter.load();

  // Load QuickView
  theme.QuickView.load();

  // Load QuickShop
  theme.QuickShop.load();

  // Load Promo Slider
  theme.PromoSlider.load();

  // move this
  theme.LeftDrawer = new theme.Drawers('NavDrawer', 'left');
  theme.RightDrawer = new theme.Drawers('CartDrawer', 'right', {
    'onDrawerOpen': ajaxCart.load
  });

  ajaxCart.init({
    formSelector: '[data-form-add-to-cart]',
    cartContainer: '#CartContainer',
    addToCartSelector: '[data-add-to-cart]',
    cartCountSelector: '#CartCount',
    cartCostSelector: '#CartCost',
    moneyFormat: theme.moneyFormat,
    domainType: theme.domainType,
    freeShippingPrice: theme.freeShippingPrice,
  });

  // Load countdowns
  theme.cache.$countdown.countdown();

  // Load Locale switcher
  theme.Localeswitcher = new theme.Localeswitcher();

  if (window.theme.gwpEnabled) {
    ajaxCartGwp.init();
  }

  theme.cache.$body.on('afterCartLoad.ajaxCart', function(evt, cart) {
    // Bind to 'afterCartLoad.ajaxCart' to run any javascript after the cart has loaded in the DOM
    $.magnificPopup.close();
    theme.RightDrawer.open();

    if (window.theme.gwpEnabled) {
      ajaxCartGwp.load();
    }
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

  app.mount();

});
